<template>
  <section>
    <el-row>

      <el-col :span="3" >
        <el-date-picker v-model="delbegin" type="date" placeholder="delivery begin" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">

        </el-date-picker>

      </el-col>
      <el-col :span="3" >
        <el-date-picker v-model="delend" type="date" placeholder="delivery end" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-col>

      <el-col :span="6">
        <el-input placeholder="Please input search words" v-model="searchKey" prefix-icon="el-icon-fa-search">
          <div slot="append">
            <el-button type="primary" icon="el-icon-fa-search"
                       @click=" onexporting=false; pager.pager.pageNumber = 1 ;doSearch()"></el-button>

            <el-button type="primary" icon="el-icon-download"
                       @click=" onexporting = true; pager.pager.pageNumber = 1 ;pager.pager.pageSize = 2000;doSearch()"></el-button>
          </div>

        </el-input>
      </el-col>

    </el-row>
    <el-row>
      <el-col :span="3">
        <el-select v-model="orderstate" multiple placeholder="order status">
          <el-option
            v-for="item in orderstatus"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="fabrecstate" multiple placeholder="fabric status">
          <el-option
            v-for="item in fabrecstatus"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <el-select v-model="cutstate" multiple placeholder="cut status">
          <el-option
            v-for="item in cutstatus"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <el-select v-model="sewstate" multiple placeholder="sew status">
          <el-option
            v-for="item in sewstatus"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <el-popover placement="bottom" title="Colums" width="300" trigger="click">

          <el-col :span="12"><el-checkbox v-model="showcolums.showref" @change="showHideCol('showref')">Ref.No.</el-checkbox></el-col>
          <el-col :span="12"><el-checkbox v-model="showcolums.showstyle" @change="showHideCol('showstyle')">Style.No.</el-checkbox></el-col>

          <el-col :span="12"><el-checkbox v-model="showcolums.showpo" @change="showHideCol('showpo')">Po.No.</el-checkbox></el-col>
          <el-col :span="12"><el-checkbox v-model="showcolums.showcolor" @change="showHideCol('showcolor')">ColorWays</el-checkbox></el-col>

          <el-col :span="12"><el-checkbox v-model="showcolums.showcmt" @change="showHideCol('showcmt')">FACTORY</el-checkbox></el-col>
          <el-col :span="12"><el-checkbox v-model="showcolums.showcust" @change="showHideCol('showcust')">CUSTOMER</el-checkbox></el-col>

          <el-col :span="12"><el-checkbox v-model="showcolums.showdes" @change="showHideCol('showdes')">DES.</el-checkbox></el-col>
          <el-col :span="12"><el-checkbox v-model="showcolums.showstatus" @change="showHideCol('showstatus')">STATUS</el-checkbox></el-col>

          <el-col :span="12"><el-checkbox v-model="showcolums.showtotal" @change="showHideCol('showtotal')">ORDER QTY</el-checkbox></el-col>
          <el-col :span="12"><el-checkbox v-model="showcolums.showdeldate" @change="showHideCol('showdeldate')">DEL.DATE</el-checkbox></el-col>

          <el-col :span="12"><el-checkbox v-model="showcolums.showfab" @change="showHideCol('showfab')">FAB.STATUS</el-checkbox></el-col>
          <el-col :span="12"><el-checkbox v-model="showcolums.showtrim" @change="showHideCol('showtrim')">TRIM.STATUS</el-checkbox></el-col>

          <el-col :span="12"><el-checkbox v-model="showcolums.showcut" @change="showHideCol('showcut')">TTL.CUT</el-checkbox></el-col>
          <el-col :span="12"><el-checkbox v-model="showcolums.showsew" @change="showHideCol('showsew')">TTL.SEW</el-checkbox></el-col>

          <el-col :span="12"><el-checkbox v-model="showcolums.showcutst" @change="showHideCol('showcutst')">CUT.STATUS</el-checkbox></el-col>
          <el-col :span="12"><el-checkbox v-model="showcolums.showsewst" @change="showHideCol('showsewst')">SEW.STATUS</el-checkbox></el-col>
          <el-button slot="reference">Column Show</el-button>
        </el-popover>
      </el-col>

    </el-row>

    <el-table id="export" :data="pager.dataList" border stripe style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="cm-table-expand">
            <el-form-item label="SizeRatio">
              <span>{{ props.row.SizeRatio }}</span>
            </el-form-item>
            <el-form-item label="ColorWays">
              <span>{{ props.row.ColorWays }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>


      <el-table-column prop="RefNo" v-if="showcolums.showref" label="Ref.No." show-overflow-tooltip head-align="center" align="center" width="80"></el-table-column>
      <el-table-column prop="StyleNo" v-if="showcolums.showstyle" label="Style.No." show-overflow-tooltip head-align="center" align="center" width="80"></el-table-column>
      <el-table-column prop="PONo" v-if="showcolums.showpo" label="Po.No." show-overflow-tooltip head-align="center" align="center" width="80"></el-table-column>

      <el-table-column prop="ColorWays"  v-if="onexporting" label="ColorWays" show-overflow-tooltip head-align="center" align="center"></el-table-column>

      <el-table-column prop="cmtFactory" v-if="showcolums.showcmt" label="FACTORY" show-overflow-tooltip head-align="center" align="center" width="120" ></el-table-column>
      <el-table-column prop="CustName" v-if="showcolums.showcust" label="CUSTOMER" show-overflow-tooltip head-align="center" align="center" width="100" ></el-table-column>
      <el-table-column prop="StDescription" v-if="showcolums.showdes" label="DES." show-overflow-tooltip head-align="center" align="center" width="200"></el-table-column>
      <el-table-column prop="CurrOrderStatus" v-if="showcolums.showstatus" label="STATUS" show-overflow-tooltip head-align="center" align="center" width="80"></el-table-column>
      <el-table-column prop="TotalQty" v-if="showcolums.showtotal" label="ORDER QTY" show-overflow-tooltip head-align="center" align="center" width="70"></el-table-column>

      <el-table-column prop="OrderDelBegin" v-if="showcolums.showdeldate" :formatter="formatRecdate" label="DEL.DATE" show-overflow-tooltip head-align="center" align="center" width="100"></el-table-column>
      <el-table-column prop="FabRecStatus" v-if="showcolums.showfab" label="FAB.STATUS" show-overflow-tooltip head-align="center" align="center" width="70"></el-table-column>
      <el-table-column prop="TrimRecStatus" v-if="showcolums.showtrim" label="TRIM.STATUS" show-overflow-tooltip head-align="center" align="center" width="70"></el-table-column>
      <el-table-column prop="CutQty" v-if="showcolums.showcut" label="TTL.CUT" show-overflow-tooltip head-align="center" align="center" width="70"></el-table-column>
      <el-table-column prop="SewQty" v-if="showcolums.showsew" label="TTL.SEW" show-overflow-tooltip head-align="center" align="center" width="70"></el-table-column>
      <el-table-column prop="CutStatus" v-if="showcolums.showcutst" label="CUT.STATUS" show-overflow-tooltip head-align="center" align="center" width="70"></el-table-column>
      <el-table-column prop="SewStatus" v-if="showcolums.showsewst" label="SEW.STATUS" show-overflow-tooltip head-align="center" align="center" width="70"></el-table-column>

      <el-table-column  label="BUY Comments" show-overflow-tooltip head-align="center" width ="120"  align="center">
        <template slot-scope="scope">
          <el-form :model="scope.row" :rules="$rules" ref="scope.row" >
            <el-form-item prop="buyercomment">
              <el-input v-show="true" size="small" v-model="scope.row.buyercomment"  style="width:100px"></el-input>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>

      <el-table-column label="DETAIL" show-overflow-tooltip header-align="center" align="center" width="170">
        <template slot-scope="scope">
          <el-button-group>

            <el-button title="detail" size="mini" type="primary" icon="el-icon-menu"
                       @click="doSearchDetail(scope.$index,scope.row)"></el-button>
            <el-button title="doc" size="mini" type="primary" icon="el-icon-document"
                       @click="doSearchDoc(scope.$index,scope.row)"></el-button>
            <el-button title="ship" size="mini" type="primary" icon="el-icon-date"
                       @click="doSearchShip(scope.$index,scope.row)"></el-button>
            <el-button title="size" size="mini" type="primary" icon="el-icon-goods"
                       @click="doSearchSize(scope.$index,scope.row)"></el-button>
            <el-button title="Comment" size="mini" type="primary" icon="el-icon-message"
                       @click="handleEdit(scope.$index,scope.row)"></el-button>

          </el-button-group>
        </template>
      </el-table-column>

    </el-table>
    <el-row>
      <el-col :span="6" :offset="18">
        <el-pagination background small style="float:right" layout="prev, pager, next"
                       :total="pager.pager.recordCount" :page-size="pager.pager.pageSize"
                       :current-page.sync="pager.pager.pageNumber" v-show="pager.pager.pageCount != 0"
                       @current-change="doSearch">
        </el-pagination>
      </el-col>
    </el-row>

    <!-- 弹框区域-->
    <el-dialog :title="ShipDetail" :visible.sync="addEditShow" width="90%">
      <el-table :data="docs" border stripe style="width: 100%">

        <el-table-column prop="ctRefNo" label="ctRefNo" head-align="center" align="center" width="100"></el-table-column>
        <el-table-column prop="EstADate" :formatter="formateta" label="ETA" show-overflow-tooltip head-align="center" align="center" width="80"></el-table-column>
        <el-table-column prop="cCName" label="Name" head-align="center" align="center"></el-table-column>
        <el-table-column prop="Color" label="Color" head-align="center" align="center" width="100"></el-table-column>
        <el-table-column prop="Spec1" label="Spec1" head-align="center" align="center" width="180"></el-table-column>
        <el-table-column prop="Spec2" label="Spec2" head-align="center" align="center" width="180"></el-table-column>
        <el-table-column prop="Unit" label="Unit" head-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="QtyOrder" label="Order.Qty." head-align="center" align="center" width="80"></el-table-column>
        <el-table-column prop="ShipQty" label="Plan.Qty" head-align="center" align="center" width="80"></el-table-column>
        <el-table-column prop="TotalShipQty" label="Act.Shipped" head-align="center" align="center" width="80"></el-table-column>
        <el-table-column prop="Rolls" label="Rolls" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="Diff" label="Balance" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="RecStatus" label="Status" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="cCompanyNameAcc" label="Supplier" head-align="center" align="center" width="80"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addEditShow = false ;">OK</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="OrderDetail" :visible.sync="detailShow" width="90%">
      <el-table :data="details" border stripe style="width: 100%">

        <el-table-column prop="EColor" label="Color" head-align="center" align="center" width="120"></el-table-column>
        <el-table-column prop="ColorMark"  label="Mark" :formatter="formatnumber" show-overflow-tooltip head-align="center" align="center" width="80"></el-table-column>
        <el-table-column prop="Unit" label="Unit" head-align="center" align="center" width="80"></el-table-column>
        <el-table-column prop="TotalQty" label="TOTAL.QTY" head-align="center" align="center" width="80"></el-table-column>
        <el-table-column prop="S0" label="S0" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="S1" label="S1" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="S2" label="S2" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="S3" label="S3" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="S4" label="S4" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="S5" label="S5" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="S6" label="S6" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="S7" label="S7" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="S8" label="S8" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="S9" label="S9" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="SA" label="S10" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="SB" label="S11" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="SC" label="S12" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="SD" label="S13" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="SE" label="S14" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="SF" label="S15" :formatter="formatnumber" head-align="center" align="center" width="60"></el-table-column>

      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailShow = false ;">OK</el-button>
      </div>
    </el-dialog>


    <el-dialog :title="planDetail" :visible.sync="planShow" width="80%">
      <el-table :data="ships" border stripe style="width: 100%">
        <el-table-column prop="EstShipDate" :formatter="formateta" label="PLAN ETD" show-overflow-tooltip head-align="center" align="center" width="100"></el-table-column>
        <el-table-column prop="ctRefNo" label="ctRefNo" head-align="center" align="center" width="120"></el-table-column>
        <el-table-column prop="CtroNo" label="CtroNo" head-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="VessName" label="VessName" head-align="center" align="center" width="280"></el-table-column>
        <el-table-column prop="cCompanyESName" label="Supplier" head-align="center" align="center" width="180"></el-table-column>
        <el-table-column prop="cCompanyType" label="Suppier Type" head-align="center" align="center" width="80"></el-table-column>
        <el-table-column prop="EstDDate" :formatter="formateta" label="ETD" head-align="center" align="center" width="100"></el-table-column>
        <el-table-column prop="EstADate" :formatter="formateta" label="ETA" head-align="center" align="center" width="100"></el-table-column>
        <el-table-column prop="Memo1"  label="Status" head-align="center" align="center" width="100"></el-table-column>

      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="planShow = false ;">OK</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="orderRatio" :visible.sync="ratioShow" width="30%">
      <el-table :data="ratios" border stripe style="width: 100%">

        <el-table-column prop="SizeName" label="SizeName" head-align="center" align="center" width="120"></el-table-column>
        <el-table-column prop="SizeRatio" label="SizeRatio" head-align="center" align="center" width="120"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ratioShow = false ;">OK</el-button>
      </div>
    </el-dialog>

  </section>

</template>
<style>
  .el-table .cell.el-tooltip {
    white-space: pre-wrap;
    max-lines: 2;
  }
  .el-table td, .el-table th{
    padding: 0;
  }
  .cm-table-expand {
    font-size: 0;
  }
  .cm-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .cm-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .el-form-item .el-form-item__label{
    width: 50%;
  }

</style>

<script>
  import ElRow from "element-ui/packages/row/src/row";
  import ElCol from "element-ui/packages/col/src/col";
  export default {
    components: {
      ElCol,
      ElRow},
    data() {
      return {
        searchKey: "",
        pager: {
          pager: {
            pageCount: 0,
            pageNumber: 1,
            pageSize: 15,
            recordCount: 0
          }
        },
        selected: [],
        docs: [],
        details:[],
        ratios:[],
        ships:[],
        ShipDetail:"Ship Detail",
        OrderDetail:"Order Detail",
        planDetail:"Shipping Plan",
        orderRatio:"Order Ratio",
        addEditShow: false,
        detailShow: false,
        ratioShow: false,
        planShow: false,
        grantShow: false,
        formLabelWidth: "120px",
        options: ['NOT RCVD','PARTIAL RCVD','FULL RCVD','CANCELLED','NOT SHIPPED'],
        orderstatus: ['ON ORDER','FULL SHIPPED','SHORT SHIP ,CANCEL THE BALANCE','CANCELLED'],
        orderstate: ["ON ORDER"],
        fabrecstatus:['FINISH','PARTIAL','NOT RCVD'],
        fabrecstate:["FINISH"],
        cutstatus:['FINISH','BALANCE','NOT START'],
        cutstate:"",
        sewstatus:['FINISH','BALANCE','NOT START'],
        sewstate:"",
        delbegin:"",
        delend:"",
        onexporting: false,
        showcolums:{
          showref:true,
          showstyle:true,
          showpo:false,
          showcolor:false,
          showcmt:true,
          showcust:true,
          showdes:true,
          showstatus:true,
          showtotal:true,
          showdeldate:true,
          showfab:true,
          showtrim:true,
          showcut:true,
          showsew:true,
          showcutst:true,
          showsewst:true
        },
        config: {
          id: 0,
          buyercomment: ""
        },
      };
    },
    computed: {
      dialogWidth() {
        return 590 * 100 / this.$utils.windowWidth() + "%";
      }
    },
    watch: {
      options: function () {
        this.selected = [];
        this.options.forEach(item => {
          if (item.selected) {
            this.selected.push(item.key);
          }
        });
      }
    },
    methods: {
      changePage() {
        if (this.searchKey) {
          this.doSearch();
        } else {
          this.loadData();
        }
      },
      doSearchDoc(index, row){
        let OrderSn = row.iPoOrderInfoSn;
        this.$api.OrderTrack.searchdoc(
          OrderSn,
          result => {
            this.docs = result.pager;
            this.addEditShow = true;
          }
        );
      },
      doSearchDetail(index, row){
        let OrderSn = row.iPoOrderInfoSn;
        this.$api.OrderTrack.searchdetail(
          OrderSn,
          result => {
            this.details = result.pager;
            this.detailShow = true;
          }
        );
      },
      doSearchShip(index, row){
        let OrderSn = row.iPoOrderInfoSn;
        this.$api.OrderTrack.searchship(
          OrderSn,
          result => {
            this.ships = result.pager;
            this.planShow = true;
          }
        );
      },
      doSearchSize(index, row){
        let OrderSn = row.iPoOrderInfoSn;
        this.$api.OrderTrack.searchratio(
          OrderSn,
          result => {
            this.ratios = result.pager;
            this.ratioShow = true;
          }
        );
      },
      doSearch() {
        if(this.delbegin == null)
          this.delbegin = "";
        if(this.delend == null)
            this.delend = "";
        let searchs = this.searchKey+"#"+this.delbegin+"#"+this.delend+"#"+this.orderstate+"#"+this.fabrecstate+"#"+this.cutstate+"#"+this.sewstate+"#"+this.pager.pager.pageSize;
        let that = this;
        this.$api.OrderTrack.search(
          this.pager.pager.pageNumber,
          searchs,
          result => {
            that.pager = result.pager;
            if(that.onexporting){

              that.exportExcel();
              //that.changepagesize();

            }
          }
        );
      },
      loadData() {
        this.$api.OrderTrack.list(this.pager.pager.pageNumber, result => {
          this.pager = result.pager;
        });
      },
      formatRecdate(row ,column){

        if(row.OrderDelBegin === "" || row.OrderDelBegin == null){

          return "";
        }else{

          return  row.OrderDelEnd.substr(0,10)+'\n'+row.OrderDelBegin.substr(0,10);
        }
      },
      formateta(row ,column){

        if(row[column.property] === "" || row[column.property] == null){
          return "";
        }else{

          return  row[column.property].substr(0,10);
        }
      },
      formatnumber(row ,column){

          if(row[column.property] == 0 || row[column.property] == "0")
              return "";
          else
              return row[column.property];

      },
      exportExcel () {

        this.$nextTick(function () {

          let wb = this.$xlsx.utils.table_to_book(document.querySelector('#export'));

          let wbout = this.$xlsx.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
          try {
            this.$filesave.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), 'orderdashboard.xlsx')
          } catch (e) {
            if (typeof console !== 'undefined') console.log(e, wbout)
          }
          that.onexporting = false;
          return wbout;
        });
        let that = this;
        that.pager.pager.pageSize = 15;
        that.pager.pager.pageNumber = 1;
        that.doSearch();

      },
      initSetttings(){

        if(!window.localStorage){
          //alert("浏览器支持localstorage");
          return false;
        }else{
          var storage=window.localStorage;

          if(storage.getItem("firstin") == null){
            storage.setItem("firstin","first");
          }
          if(storage["firstin"] == "first"){

            storage.setItem("showref",true);
            storage.setItem("showstyle",true);
            storage.setItem("showpo",true);
            storage.setItem("showcolor",false);
            storage.setItem("showcmt",true);
            storage.setItem("showcust",true);
            storage.setItem("showdes",true);
            storage.setItem("showstatus",true);
            storage.setItem("showtotal",true);
            storage.setItem("showdeldate",true);
            storage.setItem("showfab",true);
            storage.setItem("showtrim",true);
            storage.setItem("showcut",true);
            storage.setItem("showsew",true);
            storage.setItem("showcutst",true);
            storage.setItem("showsewst",true);
          }
          this.showcolums.showref = eval(storage["showref"]);
          this.showcolums.showstyle = eval(storage["showstyle"]);
          this.showcolums.showpo = eval(storage["showpo"]);
          this.showcolums.showcolor = eval(storage["showcolor"]);
          this.onexporting = eval(storage["showcolor"]);

          this.showcolums.showcmt = eval(storage["showcmt"]);
          this.showcolums.showcust = eval(storage["showcust"]);
          this.showcolums.showdes = eval(storage["showdes"]);
          this.showcolums.showstatus = eval(storage["showstatus"]);

          this.showcolums.showtotal = eval(storage["showtotal"]);
          this.showcolums.showdeldate = eval(storage["showdeldate"]);
          this.showcolums.showfab = eval(storage["showfab"]);
          this.showcolums.showtrim = eval(storage["showtrim"]);

          this.showcolums.showcut = eval(storage["showcut"]);
          this.showcolums.showsew = eval(storage["showsew"]);
          this.showcolums.showcutst = eval(storage["showcutst"]);
          this.showcolums.showsewst = eval(storage["showsewst"]);

        }
      },
      showHideCol(show){
        var storage = null;
        if(window.localStorage){
          storage = window.localStorage;
          storage.setItem("firstin","modified");
        }
          switch (show){
            case 'showref'://this.showcolums.showref = !this.showcolums.showref;
                            if(storage) storage.setItem("showref",this.showcolums.showref);
                            break;
            case 'showstyle'://this.showcolums.showstyle = !this.showcolums.showstyle;
              if(storage) storage.setItem("showstyle",this.showcolums.showstyle);
              break;
            case 'showpo'://this.showcolums.showpo = !this.showcolums.showpo;
              if(storage) storage.setItem("showpo",this.showcolums.showpo);
              break;
            case 'showcolor'://this.showcolums.showcolor = !this.showcolums.showcolor;
              this.onexporting = this.showcolums.showcolor;
              if(storage) storage.setItem("showcolor",this.showcolums.showcolor);
              break;
            case 'showcmt'://this.showcolums.showcmt = !this.showcolums.showcmt;
              if(storage) storage.setItem("showcmt",this.showcolums.showcmt);
              break;
            case 'showcust'://this.showcolums.showcust = !this.showcolums.showcust;
              if(storage) storage.setItem("showcust",this.showcolums.showcust);
              break;
            case 'showdes'://this.showcolums.showdes = !this.showcolums.showdes;
              if(storage) storage.setItem("showdes",this.showcolums.showdes);
              break;
            case 'showstatus'://this.showcolums.showstatus = !this.showcolums.showstatus;
              if(storage) storage.setItem("showstatus",this.showcolums.showstatus);
              break;
            case 'showtotal'://this.showcolums.showtotal = !this.showcolums.showtotal;
              if(storage) storage.setItem("showtotal",this.showcolums.showtotal);
              break;
            case 'showdeldate'://this.showcolums.showdeldate = !this.showcolums.showdeldate;
              if(storage) storage.setItem("showdeldate",this.showcolums.showdeldate);
              break;
            case 'showfab'://this.showcolums.showfab = !this.showcolums.showfab;
              if(storage) storage.setItem("showfab",this.showcolums.showfab);
              break;
            case 'showtrim'://this.showcolums.showtrim = !this.showcolums.showtrim;
              if(storage) storage.setItem("showtrim",this.showcolums.showtrim);
              break;
            case 'showcut'://this.showcolums.showcut = !this.showcolums.showcut;
              if(storage) storage.setItem("showcut",this.showcolums.showcut);
              break;
            case 'showsew'://this.showcolums.showsew = !this.showcolums.showsew;
              if(storage) storage.setItem("showsew",this.showcolums.showsew);
              break;
            case 'showcutst'://this.showcolums.showcutst = !this.showcolums.showcutst;
              if(storage) storage.setItem("showcutst",this.showcolums.showcutst);
              break;
            case 'showsewst'://this.showcolums.showsewst = !this.showcolums.showsewst;
              if(storage) storage.setItem("showsewst",this.showcolums.showsewst);
              break;

          }
      },
      handleEdit(index, row) {

        if(row.buyercomment != undefined)

        this.config.id = row.id;
        if(row.buyercomment != undefined)
          this.config.buyercomment = row.buyercomment;
        else
          this.config.buyercomment = "";

        var callback = result => {

          if(result.poOrderTracking != undefined){

          } else {
            this.$message({
              type: "error",
              message: "post error!"
            });
          }
          this.addEditShow = false;
        };
        this.$api.OrderTrack.update(this.config, callback);
        this.addEditShow = false;
      }

    },
    created: function () {
      this.initSetttings();
      this.loadData();
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/dashbord/DashBoard.vue